export const NO_JACKPOT:string = 'nojackpot';